module.exports = __webpack_public_path__ + "img/voice-icon3.2d884e3.png";